import { gql } from '@apollo/client';
import React from 'react';
import { useBlocksTheme } from '../components/WordPressBlocksProvider.js';
import { getStyles } from '../utils/index.js';
export function CoreCode(props) {
    var _a;
    const theme = useBlocksTheme();
    const style = getStyles(theme, Object.assign({}, props));
    const { attributes } = props;
    return (React.createElement("pre", { style: style, className: attributes === null || attributes === void 0 ? void 0 : attributes.cssClassName },
        React.createElement("code", { 
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: { __html: (_a = attributes === null || attributes === void 0 ? void 0 : attributes.content) !== null && _a !== void 0 ? _a : '' } })));
}
CoreCode.fragments = {
    key: `CoreCodeBlockFragment`,
    entry: gql `
    fragment CoreCodeBlockFragment on CoreCode {
      attributes {
        anchor
        backgroundColor
        borderColor
        className
        content
        cssClassName
        fontFamily
        fontSize
        gradient
        lock
        style
        textColor
      }
    }
  `,
};
CoreCode.config = {
    name: 'CoreCode',
};
CoreCode.displayName = 'CoreCode';
